import React from 'react'
import './HeaderPage.scss'
import { Button } from '@mui/material';
import { AddCircle  } from '@mui/icons-material';

export function HeaderPage(props) {
  const {title, btnClick} = props;
  
  return (
    <div className="row-cl gap10 middle">
      <div>
      
        <h1>{title}</h1>
      
      </div>
      {btnClick && 
      
      <div>
        <button className='bt__add' onClick={() => btnClick()}>
           <AddCircle color="primary" /> {title}
        </button>
      </div>
      }
      


      </div>
  )
}
